/* eslint-disable */
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
};

const dataaa = [
                ["qwerty12344", "Dakota Rice", "Niger", "Oud-Turnhout", "$36,738", <Link>View Image</Link>, <div ><IconButton><DeleteForeverIcon style={{ color: "red", width: "18" }} /></IconButton><IconButton><EditIcon style={{ color: "green", width: "18" }} /></IconButton></div>],
                ["qwerty12344", "Minerva Hooper", "Curaçao", "Sinaai-Waas", "$23,789", <Link>View Image</Link>],
                ["qwerty12344", "Sage Rodriguez", "Netherlands", "Baileux", "$56,142", <Link>View Image</Link>],
                ["qwerty12344", "Philip Chaney", "Korea, South", "Overland Park", "$38,735", <Link>View Image</Link>],
                ["qwerty12344", "Doris Greene", "Malawi", "Feldkirchen in Kärnten", "$63,542", <Link>View Image</Link>],
                ["qwerty12344", "Mason Porter", "Chile", "Gloucester", "$78,615", <Link>View Image</Link>]
              ];

function createData(userID, weight, length, catchDate, catchTime, image) {
        //return { ID, name, startdate, enddate, status, location, startingtime, endingtime };
    }

const useStyles = makeStyles(styles);

export default function Fish() {
  const classes = useStyles();
  return (
    <GridContainer>
    {/* <FormControl variant="filled" className={classes.formControl}>
        <InputLabel id="demo-simple-select-filled-label">Age</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={age}
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl> */}
      <Box  pl={5}>
        <InputLabel  id="demo-simple-select-outlined-label">Select Category</InputLabel>
          <Select  labelId="demo-simple-select-outlined-label" id="select" value="10">
            <MenuItem value="10">Salmon</MenuItem>
            <MenuItem value="20">Brook Trout</MenuItem>
            <MenuItem value="30">Togue</MenuItem>
            <MenuItem value="40">Cusk</MenuItem>
            <MenuItem value="50">Perch</MenuItem>
          </Select>
      </Box>
      <Box pb={10} />
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>Salmon</h4>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={["User ID", "Weight", "Length", "Catch Date", "Catch Time", "Image", "Actions"]}
              tableData= {dataaa}
            />
          </CardBody>
        </Card>
      </GridItem>
      {/* <button
  className="btn btn-lg btn-danger center modal-button"
  ref={buttonRef}
  onClick={showModal}
 >
 {triggerText}
</button> */}

    </GridContainer>
  );
}
